export class TimeUtils {
  static getUnixTimestamp(): number {
    return Math.round((new Date()).getTime() / 1000);
  }
}



// WEBPACK FOOTER //
// ./src/utils/time.utils.ts